export { default } from './OnboardingFooter';
